import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	FreudButtonModule,
	FreudTypographyModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { UserService } from 'app/services/user.service';
import { ZkuService } from 'app/services/zku.service';

import { InsightsTiersSugestionsComponent } from './insights-tiers-sugestions.component';

@NgModule({
	declarations: [InsightsTiersSugestionsComponent],
	imports: [
		CommonModule,
		TranslateModule,
		FreudTypographyModule,
		FreudButtonModule,
	],
	exports: [InsightsTiersSugestionsComponent],
	providers: [ZkuService, UserService, ActionTrackerService],
})
export class InsightsTiersSugestionsModule {}
